module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-102.9a3b5c1.woff2";